import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    PopulateApiParameter,
    SendDataToApi,
} from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SubmitContactForm";
import { submitContactUsForm } from "@store/Services/EmailService";
import { getFieldValue } from "@store/Store/Components/ContactUsForm/ContactUsFormSelectors";

addToChainAfter(chain, PopulateApiParameter, props => {
    const state = props.getState();

    ["address", "city", "countryName", "enterprise", "faxNumber", "postalCode", "stateName", "recipientName"].forEach(
        x => {
            const value = getFieldValue(state, x);
            if (value) {
                (props.apiParameter as any)[x] = value;
            }
        },
    );
});

replaceInChain(chain, SendDataToApi, async props => {
    await submitContactUsForm(props.apiParameter);
});
